import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_app_left_nav_h = _resolveComponent("app-left-nav-h")!

  return (_openBlock(), _createBlock(_component_app_left_nav_h, null, {
    top: _withCtx(() => [
      _createVNode(_component_el_menu, { "active-text-color": "#F15B22" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/talents" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/talents" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "el-icon-user" }, null, -1),
                  _createElementVNode("span", null, "Talents", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/opportunities?isArchived=false" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/opportunities?isArchived=false" }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "el-icon-s-opportunity" }, null, -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "Opportunities", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_el_tooltip, { content: "Add Opportunity" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "App-Btn-Create",
                          circle: "",
                          type: "primary",
                          icon: "el-icon-plus",
                          onClick: _ctx.createOpportunity
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/biddings" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/biddings" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "el-icon-document" }, null, -1),
                  _createElementVNode("span", null, "Bids", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/transactions" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/transactions" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "el-icon-money" }, null, -1),
                  _createElementVNode("span", null, "Transactions", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    bottom: _withCtx(() => [
      _createVNode(_component_el_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/account/startups" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/account/startups" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("span", null, "Startups", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/account/account" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/account/account" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("span", null, "Account", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/account/profile" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/account/profile" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", null, "Profile", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}